import { FC, PropsWithChildren, useState } from 'react'
import { IImport } from '../../../model/IImport'
import toast from 'react-hot-toast'
import { IImportForm } from '../../../model/IImportForm'
import useImport from '../../hooks/useImport'
import { useNavigate } from 'react-router-dom'
import Loading from '../common/loading/Loading'

const RepeatImport: FC<PropsWithChildren<{ imprt: IImport; className?: string }>> = ({
  imprt,
  className,
  children,
}) => {
  const navigate = useNavigate()
  const { repeatImport } = useImport()
  const [loading, setLoading] = useState<boolean>(false)

  const repeatSubmitHandler = async () => {
    if (loading) return

    setLoading(() => true)
    const error = await repeatImport(imprt)
    setLoading(() => false)
    if (error) return

    toast.success(`Import of ${imprt.productName} products joined to the import tasks queue`)
    navigate('/imports')
  }

  return (
    <div
      role='button'
      tabIndex={-1}
      className={`${className || ''}`}
      onClick={repeatSubmitHandler}
    >
      {loading ? <Loading size='tyny' /> : children}
    </div>
  )
}

export default RepeatImport
